import { forwardRef } from 'react';
import {
  FormElementRefImperative,
  FormInputInterface,
} from '@root/src/types/form-types';
import { useSingleFormElement } from '@root/src/hooks/useBjForm';
import { FormError } from '../FormError/FormError';

export const Switch = forwardRef<FormElementRefImperative, FormInputInterface>(
  (props, ref) => {
    // component props
    const {
      className = '',
      required,
      withError = true,
      patternMismatchMessage = '',
      customValidityMessages,
      onBlur,
      onChange,
      getValidityStates,
      hasCustomError,
      ...attributes
    } = props;

    // form elements shared logic hook
    const {
      handleInteraction, elementRef, isInvalid, errorMSG, errorClass,
    } = useSingleFormElement({
      ref,
      patternMismatchMessage,
      customValidityMessages,
      className,
      hasCustomError,
      getValidityStates,
    });

    return (
      <div>
        <label className="relative inline-flex h-7 w-12 cursor-pointer items-center">
          <input
            type="checkbox"
            // there's no need to check optional fields interactions, we do it only for required fields
            // allow adding extra functions for onChange & onBlur
            onChange={(e) => {
              if (required) handleInteraction(e);
              if (onChange) onChange(e);
            }}
            onBlur={(e) => {
              if (required) handleInteraction(e);
              if (onBlur) onBlur(e);
            }}
            className={`peer sr-only ${className}${
              isInvalid ? errorClass : ''
            }`}
            ref={elementRef}
            required={required}
            {...attributes}
          />
          <span className="block h-7 w-12 rounded-full bg-gray-300 transition-colors peer-checked:bg-green-500" />
          <span className="absolute left-1 top-1 size-5 rounded-full bg-white transition-transform duration-200 peer-checked:translate-x-5" />
        </label>
        {
          // input's error field - show only if input is required and withError is true (default true)
          required && withError && (
            <FormError errorMessage={errorMSG} isShowing={isInvalid} />
          )
        }
      </div>
    );
  },
);
